// extracted by mini-css-extract-plugin
export default {"responsive-container":"Services_responsive-container__JdEJj","responsive-iframe":"Services_responsive-iframe__yXWGC"};